import { call, put, takeLatest } from "redux-saga/effects";
import { postProjectAdminDetails } from "../http/requests/project-admin";
import { getProjectAdminData, ProjectAdminType, setVtrackLoader } from "../redux/actions";
import { toastOptions } from "../common/utils/toasterOptions";
import { toast } from "react-toastify";

function* workerSaveProjectAdminSaga({ payload }) {
  try {
    yield put(setVtrackLoader(true));
    yield call(postProjectAdminDetails, payload.data);
    let page=payload.data.pageNo;page+=1;
    let rows=payload.data.rows;
    toast.success("Data Saved", toastOptions)
    yield put(
      getProjectAdminData({
        pageNo: page,
        pageSize: rows,
        sortDir: "ASC",
        sortBy: "projectName",
        searchData: '',
        expiredAllocations: false
      })
    );
    yield put(setVtrackLoader(false));
  } catch (err) {
    toast.error(err.data.errorMessage, toastOptions)
    yield put(setVtrackLoader(false));
  }
};

export function* saveProjectAdminSaga() {
  yield takeLatest(
    ProjectAdminType.SAVE_PROJECT_ADMIN_DATA,
    workerSaveProjectAdminSaga
  );
};
